import cn from 'classnames';
import React from 'react';

import SteppedModal from 'components/SteppedModal';
import { ThreadsPostModalProps } from './types';
import { block } from './utils';

const ThreadsPostModal = React.forwardRef<SteppedModal, ThreadsPostModalProps>(
  (
    {
      title,
      show,
      steps,
      defaultStep,
      className,
      onStepChange,
      onHide,
      onExited,
    },
    ref,
  ) => {
    return (
      <SteppedModal
        baseClassName={cn(block(), className)}
        {...{
          ref,
          title,
          show,
          steps,
          defaultStep,
          onStepChange,
          onHide,
          onExited,
        }}
      />
    );
  },
);

export default ThreadsPostModal;
